/**
 * Helpers i18n pour resoudre les messages des resultats de checks.
 *
 * Pattern : un check PowerShell peut renvoyer
 *   - Message      : texte direct en EN/FR (legacy, fallback)
 *   - MessageKey   : cle i18n stable (ex: 'check.dp001.manual')
 *   - MessageVars  : hashtable d interpolation (ex: { count: 3 })
 *
 * Cote front, on prefere MessageKey si present pour afficher dans la langue
 * de l utilisateur. Sinon on tombe sur Message direct (texte d origine).
 */
import type { TFunction } from 'i18next';
import type { ControlResult } from './types';

/**
 * Retourne le message a afficher pour un ControlResult, en preferant
 * messageKey s il est defini, sinon en fallback sur message.
 *
 * @param result Le resultat d un check.
 * @param t      La fonction t de useTranslation('react-i18next').
 * @returns Le texte localise pret a afficher.
 */
export function getResultMessage(
  result: Pick<ControlResult, 'message' | 'messageKey' | 'messageVars'>,
  t: TFunction,
): string {
  if (result.messageKey) {
    // i18next renvoie la cle si elle n existe pas - dans ce cas on prefere le
    // message texte original plutot qu une cle technique.
    const translated = t(result.messageKey, result.messageVars ?? {});
    if (translated && translated !== result.messageKey) {
      return translated;
    }
  }
  return result.message ?? '';
}
